import { render, staticRenderFns } from "./ToursList.vue?vue&type=template&id=1f2a3430&scoped=true&"
import script from "./ToursList.vue?vue&type=script&lang=js&"
export * from "./ToursList.vue?vue&type=script&lang=js&"
import style1 from "./ToursList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a3430",
  null
  
)

export default component.exports